/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LocationQueryByTimeRequest
 */
export interface LocationQueryByTimeRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof LocationQueryByTimeRequest
     */
    auth_ids: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof LocationQueryByTimeRequest
     */
    start_timestamp: number;
    /**
     * 
     * @type {number}
     * @memberof LocationQueryByTimeRequest
     */
    end_timestamp: number;
}

/**
 * Check if a given object implements the LocationQueryByTimeRequest interface.
 */
export function instanceOfLocationQueryByTimeRequest(value: object): value is LocationQueryByTimeRequest {
    if (!('auth_ids' in value) || value['auth_ids'] === undefined) return false;
    if (!('start_timestamp' in value) || value['start_timestamp'] === undefined) return false;
    if (!('end_timestamp' in value) || value['end_timestamp'] === undefined) return false;
    return true;
}

export function LocationQueryByTimeRequestFromJSON(json: any): LocationQueryByTimeRequest {
    return LocationQueryByTimeRequestFromJSONTyped(json, false);
}

export function LocationQueryByTimeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LocationQueryByTimeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'auth_ids': json['auth_ids'],
        'start_timestamp': json['start_timestamp'],
        'end_timestamp': json['end_timestamp'],
    };
}

export function LocationQueryByTimeRequestToJSON(json: any): LocationQueryByTimeRequest {
    return LocationQueryByTimeRequestToJSONTyped(json, false);
}

export function LocationQueryByTimeRequestToJSONTyped(value?: LocationQueryByTimeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'auth_ids': value['auth_ids'],
        'start_timestamp': value['start_timestamp'],
        'end_timestamp': value['end_timestamp'],
    };
}

